import { useState } from 'react';

interface CopyFieldProps {
  label: string;
  value: string;
}

/** One row of the IRD-assist cheat sheet: a value the user taps to copy, then pastes into the real IRD form themselves. */
export default function CopyField({ label, value }: CopyFieldProps) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard API can be unavailable/denied — the value is still visible and selectable as a fallback.
    }
  }

  return (
    <div className="flex items-center justify-between gap-3 rounded-xl border border-slate-200 bg-white px-4 py-3">
      <div className="min-w-0">
        <p className="text-xs font-medium uppercase tracking-wide text-slate-500">{label}</p>
        <p className="truncate text-base font-semibold text-slate-900">{value || '—'}</p>
      </div>
      <button
        type="button"
        onClick={() => void handleCopy()}
        disabled={!value}
        aria-label={`Copy ${label}`}
        className="shrink-0 rounded-lg bg-slate-100 px-3 py-2 text-sm font-medium text-slate-700 active:bg-slate-200 disabled:opacity-40"
      >
        {copied ? 'Copied ✓' : 'Copy'}
      </button>
    </div>
  );
}
